import { ProductsConfigs } from "entities/products/types";
import { Studio, StudioDetailsTabs } from "entities/studios/types";
import { Dispatch, SetStateAction } from "react";
import { InputHookResult } from "shared/hooks/useInputState";
import { Translations } from "shared/types/languages";

export type StudioFile = File | null;

export type StudioType = {
  selectedTab: StudioDetailsTabs;
  setSelectedTab: Dispatch<SetStateAction<StudioDetailsTabs>>;
  studioDetails?: Studio | null;
  logoFile: StudioFile;
  setLogoFile: Dispatch<SetStateAction<StudioFile>>;
  onSaveStudioDetails: () => void;
  onSaveStudioTranslations: () => void;
  isSubmittingStudio: boolean;
  isLoadingLogoFile: boolean;
  studioName: InputHookResult;
  studioDescription: InputHookResult;
  studioCurrencies: string[];
  setStudioCurrencies: Dispatch<SetStateAction<string[]>>;
  translations?: Translations;
  setTranslations: Dispatch<SetStateAction<Translations | undefined>>;
  productConfigs: ProductsConfigs | undefined;
  setProductConfigs: Dispatch<SetStateAction<ProductsConfigs | undefined>>;
  onCloseStudioDetails: () => void;
};

export enum ManagedTranslations {
  Name = "Name",
  Description = "Description",
}
